import { GetPackageTransportModel } from "@factory/model/query-model-package-transport";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { packageTransportFormDefault } from "./form.default";
import { PackageTransportFormSchema } from "./form.rule";

export const useFormDefaultPackageTransport = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPackageTransportModel | undefined) => {
    return !cachedValue
      ? packageTransportFormDefault
     : ({
        package: cachedValue.package,
        transport: cachedValue.transport,
        transportType: cachedValue.transport_type,
        fromLocation: cachedValue.from_location,
        toLocation: cachedValue.to_location,
        pricePerPax: cachedValue.price_per_pax,
        numPeople: cachedValue.num_people,
        unit: cachedValue.unit,
        amount: cachedValue.amount,
        description: cachedValue.description,
      } as PackageTransportFormSchema);
  };

  return {
    getDefault,
  };
};
